import React from "react";

const BasicModal = ({ onCancel, title, body, isHtml = false }) => {
  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>{title}</h3>
      </div>
      <div className="basic-modal__body">
        {isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: body }} />
        ) : (
          <div className="">{body}</div>
        )}
        <div className="basic-modal__footer">
          <button onClick={onCancel} className="button button--primary">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default BasicModal;
